export default function handleSubpageNavigations(){
    let $elements = $('.js-subpage-nav');

    $elements.each(function () {
        handleSubpageNavigation($(this));
    });
}


function handleSubpageNavigation($element) {
    $element.on("click", ".js-toggle-subpage-nav", function () {
        let $parent = $(this).parent(".js-subpage-nav");
        $parent.toggleClass("subpage-nav--active");
        $parent.find(".subpage-nav__menu").stop().slideToggle();
    });
}
